import { Statistics } from './Statistics'

export interface StatisticsDTO {
  id: string
  value: number
  userId: string
  date: Date
}

export function fromModel(t: Statistics): StatisticsDTO {
  return {
    id: t.id,
    value: t.value,
    userId: t.userId,
    date: t.date,
  }
}

export function toModel(d: StatisticsDTO): Statistics {
  return new Statistics(d)
}
